import React from "react";

import PageHeading from "2g-page-heading";

import TextComponent from "b2b/components/text-component";

export function TextComponentExample() {
  return (
    <>
      <PageHeading>Text component - loading</PageHeading>
      <div data-testid="loading">
        <TextComponent loading={true}>Náhodný text.</TextComponent>
      </div>
      <PageHeading>Text component - not loading</PageHeading>
      <div data-testid="notLoading">
        <TextComponent loading={false}>Náhodný text.</TextComponent>
      </div>
    </>
  );
}

export default React.memo(TextComponentExample);
